{
  "AUTOMATION": {
    "HEADER": "Automation",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Add Automation Rule",
    "LOADING": "Fetching automation rules",
    "ADD": {
      "TITLE": "Add Automation Rule",
      "SUBMIT": "Opprett",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "FORM": {
        "NAME": {
          "LABEL": "Rule Name",
          "PLACEHOLDER": "Enter rule name",
          "ERROR": "Name is required"
        },
        "DESC": {
          "LABEL": "Beskrivelse",
          "PLACEHOLDER": "Enter rule description",
          "ERROR": "Description is required"
        },
        "EVENT": {
          "LABEL": "Event",
          "PLACEHOLDER": "Please select one",
          "ERROR": "Event is required"
        },
        "PHASE": {
          "LABEL": "Fase"
        },
        "ORDER": {
          "LABEL": "Rekkefølge",
          "ERROR": "Rekkefølge er påkrevd"
        },
        "CONDITIONS": {
          "LABEL": "Conditions"
        },
        "ACTIONS": {
          "LABEL": "Handlinger"
        }
      },
      "CONDITION_BUTTON_LABEL": "Add Condition",
      "ACTION_BUTTON_LABEL": "Add Action",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule added successfully",
        "ERROR_MESSAGE": "Could not able to create a automation rule, Please try again later"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Fase",
        "ORDER": "Rekkefølge",
        "NAME": "Navn",
        "DESCRIPTION": "Beskrivelse",
        "ACTIVE": "Active",
        "CREATED_ON": "Created on",
        "WAIT": "Ventetid"
      },
      "404": "No automation rules found",
      "TABS": {
        "ALL": "Alle",
        "INSTANT": "Ved hendelse",
        "DELAYED": "Forsinkede"
      },
      "WAITS": "Venter {duration}"
    },
    "DELETE": {
      "TITLE": "Delete Automation Rule",
      "SUBMIT": "Slett",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "CONFIRM": {
        "TITLE": "Bekreft sletting",
        "MESSAGE": "Er du sikker på at du vil slette ",
        "YES": "Ja, slett ",
        "NO": "Nei, behold "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automation rule deleted successfully",
        "ERROR_MESSAGE": "Could not able to delete a automation rule, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Edit Automation Rule",
      "SUBMIT": "Oppdater",
      "CANCEL_BUTTON_TEXT": "Avbryt",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule updated successfully",
        "ERROR_MESSAGE": "Could not update automation rule, Please try again later"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clone",
      "API": {
        "SUCCESS_MESSAGE": "Automation cloned successfully",
        "ERROR_MESSAGE": "Could not clone automation rule, Please try again later"
      }
    },
    "FORM": {
      "EDIT": "Rediger",
      "CREATE": "Opprett",
      "DELETE": "Slett",
      "CANCEL": "Avbryt",
      "RESET_MESSAGE": "Changing event type will reset the conditions and events you have added below"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "You need to have atleast one condition to save",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "You need to have atleast one action to save",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Enter your message here",
      "TEAM_DROPDOWN_PLACEHOLDER": "Select teams",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Velg e-postinnboks og avsenderadresse",
      "SUBJECT_INPUT_PLACEHOLDER": "E-postens emne",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Velg SMS-innboksen det skal sendes fra",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Skriv inn SMS-teksten",
      "SMS_COUNTER": "{length}/{limit} tegn, {segments} SMS (før variablene er fylt ut)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activate Automation Rule",
      "DEACTIVATION_TITLE": "Deactivate Automation Rule",
      "ACTIVATION_DESCRIPTION": "This action will activate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "DEACTIVATION_DESCRIPTION": "This action will deactivate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "ACTIVATION_SUCCESFUL": "Automation Rule Activated Successfully",
      "DEACTIVATION_SUCCESFUL": "Automation Rule Deactivated Successfully",
      "ACTIVATION_ERROR": "Could not Activate Automation, Please try again later",
      "DEACTIVATION_ERROR": "Could not Deactivate Automation, Please try again later",
      "CONFIRMATION_LABEL": "Yes",
      "CANCEL_LABEL": "No"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Could not upload attachment, Please try again",
      "LABEL_IDLE": "Upload Attachment",
      "LABEL_UPLOADING": "Laster opp...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Upload Failed"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Value is required",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Denne handlingen fungerer bare når regelens fase er satt til 'Før merking'.",
      "SKIP_AUTO_LABELING": "Denne handlingen fungerer bare når regelens fase er satt til 'Før merking'.",
      "MOVE_CONVERSATION_TO_INBOX": "Kun e-post- og nettchatsamtaler kan flyttes til en e-postinnboks, og en nettchat bare hvis kontakten har en e-postadresse. Ellers blir samtalen der den er, og i stedet legges det til et privat notat.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Starter en ny samtale med kontakten i den valgte e-postinnboksen, sender meldingen til kontakten på e-post og markerer samtalen som løst. Dette skjer hver gang regelen kjører. Hvis kontakten ikke har en e-postadresse, sendes ingenting, og et privat notat legges til i stedet.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Starter en ny samtale med kontakten i den valgte SMS-innboksen, sender meldingen til kontakten som SMS og markerer samtalen som løst. Dette skjer hver gang regelen kjører. Meldingen er ren tekst uten vedlegg. Hvis kontakten ikke har et telefonnummer, sendes ingenting, og et privat notat legges til i stedet."
    },
    "NOTICES": {
      "AI_PROMPT": "Hver enkelt vurdering faktureres.",
      "INCOMING_MESSAGES_COUNT": "Dette refererer til antall innkommende meldinger i samtalen.",
      "OUTGOING_MESSAGES_COUNT": "Dette refererer til antall utgående meldinger i samtalen."
    },
    "PHASE": {
      "BEFORE_LABELING": "Før merking",
      "AFTER_LABELING": "Etter merking"
    },
    "NONE_OPTION": "Ingen",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Innkommende melding",
      "OUTGOING": "Utgående melding",
      "PRIVATE": "Privat notat",
      "AI_SUMMARY": "AI-sammendrag"
    },
    "YES_NO_VALUES": {
      "YES": "Ja",
      "NO": "Nei"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Direktemelding på Instagram",
      "FACEBOOK_COMMENT": "Facebook-kommentar"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Samtale opprettet",
      "CONVERSATION_UPDATED": "Samtale oppdatert",
      "MESSAGE_CREATED": "Melding opprettet",
      "CONVERSATION_OPENED": "Samtale åpnet",
      "CONVERSATION_RESOLVED": "Samtale løst",
      "PHONE_CALL_FINISHED": "Anrop avsluttet"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Tildel til agent",
      "ASSIGN_TEAM": "Tildel et team",
      "ADD_LABEL": "Legg til en etikett",
      "REMOVE_LABEL": "Fjern en etikett",
      "SEND_EMAIL_TO_TEAM": "Send en e-post til team",
      "SEND_EMAIL_TRANSCRIPT": "Send en e-posttranskripsjon",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Send en detaljert e-posttranskripsjon",
      "MUTE_CONVERSATION": "Demp samtale",
      "SNOOZE_CONVERSATION": "Snooze samtale",
      "RESOLVE_CONVERSATION": "Løs samtale",
      "OPEN_CONVERSATION": "Åpne samtale",
      "SEND_WEBHOOK_EVENT": "Send webhook-hendelse",
      "SEND_ATTACHMENT": "Send vedlegg",
      "SEND_MESSAGE": "Send en melding",
      "ADD_NOTE": "Legg til et notat",
      "CHANGE_PRIORITY": "Endre prioritet",
      "ADD_SLA": "Legg til SLA",
      "SKIP_AUTO_PRIORITY": "Hopp over automatisk prioritet",
      "SKIP_AUTO_LABELING": "Hopp over automatisk merking",
      "AUTO_TRANSLATE": "Oversett melding",
      "AUTO_TRANSLATE_CONVERSATION": "Oversett samtale",
      "MOVE_CONVERSATION_TO_INBOX": "Flytt samtale til innboks",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Send melding i en ny samtale",
      "SEND_SMS_IN_NEW_CONVERSATION": "Send SMS i en ny samtale",
      "STOP_PROCESSING_RULES": "Stopp behandling av regler"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "AI-filter",
      "MESSAGE_TYPE": "Meldingstype",
      "MESSAGE_CONTAINS": "Meldingsinnhold",
      "EMAIL": "E-post",
      "INBOX": "Innboks",
      "CHANNEL_TYPE": "Innbokstype",
      "CONVERSATION_LANGUAGE": "Samtalespråk",
      "PHONE_NUMBER": "Telefonnummer",
      "STATUS": "Status",
      "BROWSER_LANGUAGE": "Nettleserspråk",
      "MAIL_SUBJECT": "E-postemne",
      "COUNTRY_NAME": "Land",
      "MARKETPLACE_COUNTRY": "Markedsplassland",
      "REFERER_LINK": "Henvisningslenke",
      "ASSIGNEE_NAME": "Tildelt til",
      "TEAM_NAME": "Team",
      "PRIORITY": "Prioritet",
      "CALL_DIRECTION": "Samtaleretning",
      "MISSED_CALL": "Tapt anrop",
      "MISSED_CALL_COUNT": "Antall tapte anrop",
      "MESSAGE_SOURCE_TYPE": "Meldingskildetype",
      "INCOMING_MESSAGE_COUNT": "Antall innkommende meldinger",
      "OUTGOING_MESSAGE_COUNT": "Antall utgående meldinger",
      "LABEL": "Etikett",
      "EMAIL_RECIPIENTS": "E-postmottaker",
      "EMAIL_AUTO_REPLY": "E-posten er et automatisk svar",
      "ATTACHMENT_EXTENSION": "Filtype for vedlegg",
      "EXTENSION": "Oppringt internnummer",
      "WORKING_HOURS": "Innenfor arbeidstid",
      "AGENT_REPLIED": "Agent har svart siden statusendringen"
    },
    "WAIT": {
      "RUN_LABEL": "Utfør handlingene",
      "INSTANT": "Ved hendelse",
      "DELAYED": "Forsinket",
      "TRIGGER_LABEL": "Vent til",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "En samtale blir værende i en status",
        "CUSTOMER_UNRESPONSIVE": "Kunden svarer ikke en agent",
        "AGENT_UNRESPONSIVE": "Kunden får ikke svar fra en agent"
      },
      "STATUS_LABEL": "Status",
      "STATUSES": {
        "OPEN": "Åpen",
        "PENDING": "Venter",
        "SNOOZED": "Utsatt",
        "RESOLVED": "Løst"
      },
      "DELAY_LABEL": "Ventetid",
      "DELAY_ERROR": "Angi en ventetid mellom 1 minutt og 30 dager",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} t",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Handlingene utføres når en samtale har hatt status {status} i {duration}. En statusendring før det avbryter dem. Etiketter, arbeidstid og agentsvar kontrolleres når ventetiden er over.",
        "CUSTOMER_UNRESPONSIVE": "Handlingene utføres når kunden ikke har svart på en agents melding på {duration}. Et svar fra kunden avbryter dem; en ny melding fra agenten starter ventetiden på nytt.",
        "AGENT_UNRESPONSIVE": "Handlingene utføres når kunden har ventet {duration} uten svar fra en agent. Et svar fra agenten avbryter dem."
      }
    }
  }
}
